"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGrid = createGrid;
exports.generateRandomSequence = generateRandomSequence;
exports.enableBlock = enableBlock;
exports.disableBlock = disableBlock;
const __1 = require("../../..");
function createGrid({ x, y, numOfBlocks, blockSize, gridSize, blockSpacing }) {
    const blocks = [];
    const numRows = gridSize;
    const numCols = numOfBlocks / gridSize;
    for (let row = 0; row < numRows; row++) {
        for (let col = 0; col < numCols; col++) {
            const blockX = x + col * (blockSize + blockSpacing);
            const blockY = y + row * (blockSize + blockSpacing);
            blocks.push({ x: blockX, y: blockY });
        }
    }
    return blocks;
}
function generateRandomSequence({ numOfBlocks, sequenceLength, previousSequence = null }) {
    const sequence = [];
    for (let i = 0; i < sequenceLength; i++) {
        const randomNumber = Math.floor(Math.random() * numOfBlocks);
        // Avoid highlighting the same square twice in a row,
        // even across trial sequences
        // Check the last square in the previous sequence
        if (i == 0 && previousSequence && previousSequence[previousSequence.length - 1] === randomNumber) {
            i--;
            continue;
        }
        // Check the previous square in the current sequence
        if (sequence[sequence.length - 1] === randomNumber) {
            i--;
            continue;
        }
        sequence.push(randomNumber);
    }
    return sequence;
}
function addAnimation(element, animation) {
    if (animation === 'cursor') {
        const cursorImageSrc = __1.mediaAssets.images.cursor;
        // Ensure element has position relative for absolute positioning of cursor image
        if (element.style.position !== 'relative' &&
            element.style.position !== 'absolute' &&
            element.style.position !== 'fixed') {
            element.style.position = 'relative';
        }
        // Remove existing cursor image if it exists
        removeCursorImage(element);
        // Create and add cursor image
        const cursorImg = document.createElement('img');
        cursorImg.src = cursorImageSrc;
        cursorImg.className = 'corsi-cursor-image';
        cursorImg.style.position = 'absolute';
        cursorImg.style.top = '50%';
        cursorImg.style.left = '50%';
        cursorImg.style.transform = 'translate(-50%, -50%)';
        cursorImg.style.pointerEvents = 'none';
        cursorImg.style.zIndex = '10';
        cursorImg.style.animation = 'pulse 2s infinite';
        element.appendChild(cursorImg);
    }
    else if (animation === 'pulse') {
        element.style.animation = 'pulse 2s infinite';
        element.style.backgroundColor = '#275BDD';
    }
}
// removes the cursor image from a corsi block element if it exists
function removeCursorImage(element) {
    const existingCursor = element.querySelector('.corsi-cursor-image');
    if (existingCursor) {
        existingCursor.remove();
    }
}
// enables a corsi block element, making it clickable and fully visible, and also adds an animation
function enableBlock(element, animation) {
    element.style.pointerEvents = 'auto';
    element.style.opacity = '1';
    element.style.cursor = 'pointer';
    element.style.backgroundColor = ' #ffffffcc';
    if (animation) {
        addAnimation(element, animation);
    }
}
// disables a corsi block element, making it non-clickable and visually dimmed
function disableBlock(element) {
    element.style.pointerEvents = 'none';
    element.style.opacity = '0.5';
    element.style.cursor = 'not-allowed';
    element.style.backgroundColor = 'rgba(215, 215, 215, 0.93)';
    // disable any ongoing animations
    removeCursorImage(element);
    element.style.animation = 'none';
}
